<div class="col-12 card-planning">
    <div class="row planning">
      <table class="col-12">
        <thead>

          <tr>
            <th colspan="48" *ngFor="let day of dayCount;">{{day | date:"dd/MM/yy"}}</th>
          <tr>
          <tr>
            <th class="hour" colspan="2" *ngFor="let hour of hourCount;"><label>{{hour}}</label></th>

            <!-- <th colspan="2">00h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">02h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">04h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">06h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">08h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">10h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">12h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">14h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">16h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">18h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">20h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">22h</th>
              <th colspan="2" class="blank">___</th>
              <th colspan="2">00h</th> -->

          </tr>
          <tr>

            <th class="hour" colspan="2" *ngFor="let hour of hourCount;">|</th>

          </tr>

        </thead>
        <tbody>
          <tr>
            <td class="content-resa"> </td>

            <td class="content-resa" *ngFor="let availabilitie of availabilities;" [ngClass]="availabilitie">
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>